import React, { useEffect } from "react";
import { Grid, GridColumn } from "semantic-ui-react";
import { useStore } from "../../../app/stores/store";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";
import GameDetailedInfo from "./GameDetailedInfo";
import GameDetailedChat from "./GameDetailedChat";
import GameDetailedSidebar from "./GameDetailedSidebar";
import GameDetailedHeader from "./GameDetailedHeader";
import GameVideoLinksPanel from "./GameVideoLinksPanel";

export default observer(function GameDetails() {
    const { gameStore, commonStore, userStore } = useStore();
    const { selectedGame: game, loadGame, loadingInitial, clearSelectedGame } = gameStore;
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const location = useLocation();

    // Authentication check
    useEffect(() => {
        if (commonStore.appLoaded && !userStore.isLoggedIn) {
            // Store the current URL before redirecting to login
            userStore.setPendingRedirectUrl(location.pathname + location.search);
            navigate('/login');
            return;
        }
    }, [commonStore.appLoaded, userStore.isLoggedIn, navigate, location, userStore]);

    // Load game data
    useEffect(() => {
        if (commonStore.appLoaded && userStore.isLoggedIn && id) {
            loadGame(id, true); // always force fetch when coming to GameDetails
        }

        return () => clearSelectedGame();
    }, [commonStore.appLoaded, userStore.isLoggedIn, id, loadGame, clearSelectedGame]);

    // Show loading while checking authentication
    if (!commonStore.appLoaded) return <LoadingComponent content="Checking auth..." />;

    // Don't render anything if not logged in (will be redirected)
    if (!userStore.isLoggedIn) return null;

    // Show loading while fetching game data
    if (loadingInitial || !game) return <LoadingComponent content="Loading game..." />;

    return (
        <Grid>
            <GridColumn width={16}> 
                <GameDetailedHeader game={game}/>
                <GameDetailedSidebar game={game}/>
                <GameVideoLinksPanel game={game} /> 
                <GameDetailedChat game={game}/>
                <GameDetailedInfo game={game}/>           
            </GridColumn>
        </Grid>
    );
});